import { render } from "./OfferIndex.vue?vue&type=template&id=231f02a0&ts=true"
import script from "./OfferIndex.vue?vue&type=script&lang=ts"
export * from "./OfferIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__